"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCenter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 325.818c-102.865 0-186.182 83.317-186.182 186.182S409.135 698.182 512 698.182 698.182 614.865 698.182 512 614.865 325.818 512 325.818zm416.116 139.637c-21.41-194.095-175.476-348.16-369.57-369.571V0h-93.091v95.884c-194.095 21.41-348.16 175.476-369.571 369.57H0v93.091h95.884c21.41 194.095 175.476 348.16 369.57 369.571V1024h93.091v-95.884c194.095-21.41 348.16-175.476 369.571-369.57H1024v-93.091h-95.884zM512 837.818c-180.13 0-325.818-145.687-325.818-325.818 0-180.13 145.687-325.818 325.818-325.818 180.13 0 325.818 145.687 325.818 325.818 0 180.13-145.687 325.818-325.818 325.818z"
  }));
}

var ForwardRef = React.forwardRef(SvgCenter);
var _default = ForwardRef;
exports.default = _default;